"use strict";

/**
 * dataCloudSignupForm.client.js
 * Client-side handler for Data Cloud Signup Form components.
 * - Finds all .dc-signup-form-component instances on the page
 * - Fetches form configuration from Data Cloud Interactions SDK
 * - Dynamically renders form fields from the personalization attributes
 * - On submit, fires DataCloudInteractions.sendEvent calls
 */

var dcFormEls = document.querySelectorAll(".dc-signup-form-component");

if (dcFormEls.length > 0) {
    var formInterval = setInterval(function () {
        if (
            window.DataCloudInteractions &&
            typeof window.DataCloudInteractions.init === "function"
        ) {
            clearInterval(formInterval);

            DataCloudInteractions.init({
                consents: [],
                personalization: { dataspace: "default" }
            }).then(function () {
                dcFormEls.forEach(function (formEl) {
                    initDCForm(formEl);
                });
            }).catch(function (err) {
                console.error("DataCloudInteractions init error:", err);
                dcFormEls.forEach(function (formEl) {
                    hideForm(formEl);
                });
            });
        }
    }, 100);
}

/**
 * Initializes Data Cloud form
 * @param {HTMLElement} formEl - the .dc-signup-form-component wrapper element
 */
function initDCForm(formEl) {
    var personalizationPoint = formEl.getAttribute("data-personalization-point");

    if (!personalizationPoint) {
        hideForm(formEl);
        return;
    }

    DataCloudInteractions.Personalization.fetch([personalizationPoint])
        .then(function (response) {
            var personalizations = response && response.personalizations;

            if (!personalizations || personalizations.length === 0) {
                hideForm(formEl);
                return;
            }

            var personalization = personalizations[0];
            var attributes = personalization.attributes || {};

            // Page Designer headline takes priority, Data Cloud Form_Name is the fallback
            var headline = formEl.getAttribute("data-headline") ||
                attributes.Form_Name ||
                null;

            // Get the fields — supports up to 10 fields
            var fields = [];
            for (var i = 1; i <= 10; i++) {
                var labelKey = "Field_" + i;
                var typeKey = "Field_" + i + "_Type";
                if (attributes[labelKey]) {
                    fields.push({
                        index: i,
                        label: attributes[labelKey],
                        type: attributes[typeKey] || "text"
                    });
                }
            }

            if (fields.length === 0) {
                hideForm(formEl);
                return;
            }

            var submitLabel = attributes.Submit_Label || "Submit";
            var disclaimer = attributes.Disclaimer || null;

            buildForm(formEl, headline, fields, submitLabel, disclaimer, personalizationPoint);
        })
        .catch(function (err) {
            console.error("DataCloudInteractions fetch error:", err);
            hideForm(formEl);
        });
}

/**
 * Maps a field label to a Data Cloud identity attribute key.
 * Used for text fields to determine the sendEvent payload key.
 * @param {string} label
 * @returns {string|null}
 */
function getIdentityKey(label) {
    var l = label.toLowerCase();
    if (l.includes("first")) return "firstName";
    if (l.includes("last"))  return "lastName";
    return null;
}

/**
 * Gets the Contact Key from URL parameters to be used for Party Identification
 * @returns {string|null}
 */
function getSPFormContactId() {
    var params = new URL(document.location).searchParams;
    return params.get("utm_ContactKey") || null;
}

/**
 * Builds and injects the form HTML into the component wrapper.
 * @param {HTMLElement} formEl
 * @param {string|null} headline
 * @param {Array} fields
 * @param {string} submitLabel
 * @param {string|null} disclaimer
 * @param {string} personalizationPoint
 */
function buildForm(formEl, headline, fields, submitLabel, disclaimer, personalizationPoint) {
    var formId = formEl.id + "-form";
    var displayMode = (formEl.getAttribute("data-display-mode") || "inline").toLowerCase();
    var modalImageSrc = formEl.getAttribute("data-modal-image") || "";
    var modalImageAlt = formEl.getAttribute("data-modal-image-alt") || "";
    var innerHTML = "";

    if (headline) {
        innerHTML += '<h3 class="dc-signup-form-heading">' + headline + "</h3>";
    }

    innerHTML += '<form id="' + formId + '" class="dc-signup-form row" novalidate>';

    fields.forEach(function (field) {
        var fieldId = formEl.id + "-field-" + field.index;
        var patternAttr = '';
        var patternMismatchMsg = '';

        if (field.type === 'email') {
            patternAttr = ' pattern="[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}"';
            patternMismatchMsg = ' data-pattern-mismatch="Please enter a valid email address"';
        } else if (field.type === 'tel') {
            patternAttr = ' pattern="[0-9]{10}"';
            patternMismatchMsg = ' data-pattern-mismatch="Please enter a valid 10-digit phone number"';
        }

        innerHTML += '<div class="dc-signup-form-field  col-md-6 form-group mb-1">';
        innerHTML += '<label class="dc-signup-form-label form-control-label" for="' + fieldId + '">' + field.label + '</label>';
        innerHTML += '<input class="dc-signup-form-input form-control"';
        innerHTML += ' id="' + fieldId + '"';
        innerHTML += ' type="' + field.type + '"';
        innerHTML += ' name="field_' + field.index + '"';
        innerHTML += ' required';
        innerHTML += ' data-missing-error="' + field.label + ' is required"';
        innerHTML += patternAttr;
        innerHTML += patternMismatchMsg;
        innerHTML += ' />';
        innerHTML += '<div class="invalid-feedback"></div>';
        innerHTML += '</div>';
    });

    innerHTML += '<div class="col-12 mb-1"><button type="submit" class="dc-signup-form-submit btn btn-primary">' + submitLabel + '</button>';

    if (disclaimer) {
        innerHTML += '<p class="dc-signup-form-disclaimer mt-1">' + disclaimer + '</p></div>';
    }

    innerHTML += '</form>';
    innerHTML += '<div class="dc-signup-form-success" style="display:none;">';
    innerHTML += '<p class="dc-signup-form-success-msg">Thank you for signing up!</p>';
    innerHTML += '</div>';

    if (displayMode === 'modal') {
        var modalId = formEl.id + '-modal';
        var modalHeaderContent = '';
        if (modalImageSrc) {
            modalHeaderContent += '<div class="dc-signup-form-modal-image-wrap">' +
                '<img class="dc-signup-form-modal-image" src="' + modalImageSrc + '" alt="' + modalImageAlt + '" />' +
                '</div>';
        }

        innerHTML = '<div id="' + modalId + '" class="dc-signup-form-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true" aria-modal="true">' +
            '<div class="modal-dialog modal-dialog-centered" role="document">' +
            '<div class="modal-content">' +
            '<div class="modal-header dc-signup-form-modal-header border-0">' +
            modalHeaderContent +
            '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
            '</div>' +
            '<div class="modal-body">' + innerHTML + '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
    }

    formEl.innerHTML = innerHTML;

    var formDomEl = document.getElementById(formId);
    if (formDomEl) {
        attachSubmitHandler(formDomEl, fields, formEl, personalizationPoint);

        $(formDomEl).find('input').on('invalid', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).addClass('is-invalid');
                if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                }
                $(this).parents('.form-group').find('.invalid-feedback').text(validationMessage);
            }
        });

        $(formDomEl).find('input').on('change input', function () {
            if ($(this).hasClass('is-invalid')) {
                $(this).removeClass('is-invalid');
                $(this).parents('.form-group').find('.invalid-feedback').text('');
            }
        });
    }

    if (displayMode === 'modal') {
        var modalDomEl = formEl.querySelector('.dc-signup-form-modal');
        if (modalDomEl) {
            var modalDelay = parseInt(formEl.getAttribute('data-modal-delay'), 10) || 0;
            var suppressDays = parseInt(formEl.getAttribute('data-suppress-days'), 10) || 30;

            $(modalDomEl).on('hidden.bs.modal', function () {
                setDcSignupSuppression(formEl, personalizationPoint, suppressDays);
            });

            if (!isDcSignupSuppressed(formEl, personalizationPoint)) {
                setTimeout(function () {
                    $(modalDomEl).modal('show');
                }, modalDelay * 1000);
            }
        }
    }
}

/**
 * Attaches the submit event handler to the rendered form.
 * Fires DataCloudInteractions.sendEvent calls on submission.
 * @param {HTMLFormElement} formDomEl
 * @param {Array} fields
 * @param {HTMLElement} formEl
 * @param {string} personalizationPoint
 */
function getDcSignupSuppressionKey(personalizationPoint) {
    return 'dc-signup-form-suppressed-' + (personalizationPoint || 'default');
}

function isDcSignupSuppressed(formEl, personalizationPoint) {
    var key = getDcSignupSuppressionKey(personalizationPoint || formEl.getAttribute('data-personalization-point'));
    try {
        var raw = window.localStorage && window.localStorage.getItem(key);
        if (!raw) {
            return false;
        }
        var expiry = parseInt(raw, 10);
        return !isNaN(expiry) && expiry > Date.now();
    } catch (e) {
        return false;
    }
}

function setDcSignupSuppression(formEl, personalizationPoint, suppressDays) {
    var key = getDcSignupSuppressionKey(personalizationPoint || formEl.getAttribute('data-personalization-point'));
    var expiry = Date.now() + ((parseInt(suppressDays, 10) || 30) * 24 * 60 * 60 * 1000);
    try {
        if (window.localStorage) {
            window.localStorage.setItem(key, String(expiry));
        }
    } catch (e) {
        // ignore storage failures gracefully
    }
}

function attachSubmitHandler(formDomEl, fields, formEl, personalizationPoint) {
    formDomEl.addEventListener("submit", function (event) {
        event.preventDefault();

        var identityAttributes = {
            eventType: "identity",
            isAnonymous: "0",
            deviceId: DataCloudInteractions.getAnonymousId()
        };
        var contactId = getSPFormContactId();
        var emailValue = null;
        var phoneValue = null;
        var interactionName = (personalizationPoint + "_Submit").replace(/\s+/g, "_");
        var suppressDays = parseInt(formEl.getAttribute('data-suppress-days'), 10) || 30;

        // Clear previous errors
        $(formDomEl).find('.form-control.is-invalid').removeClass('is-invalid');
        $(formDomEl).find('.invalid-feedback').text('');

        // Validate — trigger invalid events on each invalid input
        if (!formDomEl.checkValidity()) {
            $(formDomEl).find('input, select').each(function () {
                if (!this.validity.valid) {
                    $(this).trigger('invalid', this.validity);
                }
            });
            return;
        }

        // Loop fields and collect values
        fields.forEach(function (field) {
            var fieldId = formEl.id + "-field-" + field.index;
            var input = document.getElementById(fieldId);
            var value = input ? input.value.trim() : "";

            if (!value) return;

            if (field.type === "email") {
                emailValue = value;
            } else if (field.type === "tel") {
                phoneValue = value;
                identityAttributes.phoneNumber = value;
            } else {
                var identityKey = getIdentityKey(field.label);
                if (identityKey) {
                    identityAttributes[identityKey] = value;
                }
            }
        });

        // 1. User Engagement event
        DataCloudInteractions.sendEvent({
            interaction: {
                name: interactionName
            },
            user: {
                attributes: {
                    eventType: "userEngagement",
                    interactionName: interactionName,
                    pageUrl: window.location.href,
                    deviceId: DataCloudInteractions.getAnonymousId()
                }
            }
        });

        // 2. Identity event — name, phone
        DataCloudInteractions.sendEvent({
            interaction: { name: interactionName },
            user: { attributes: identityAttributes }
        });

        // 3. Contact Point Email
        if (emailValue) {
            DataCloudInteractions.sendEvent({
                interaction: { name: interactionName },
                user: {
                    attributes: {
                        eventType: "contactPointEmail",
                        email: emailValue
                    }
                }
            });
        }

        // 4. Contact Point Phone
        if (phoneValue) {
            DataCloudInteractions.sendEvent({
                interaction: { name: interactionName },
                user: {
                    attributes: {
                        eventType: "contactPointPhone",
                        phoneNumber: phoneValue
                    }
                }
            });
        }

        // 5. Party Identification — Contact ID from utm_ContactKey
        if (contactId) {
            DataCloudInteractions.sendEvent({
                interaction: { name: interactionName },
                user: {
                    attributes: {
                        eventType: "partyIdentification",
                        userId: contactId,
                        IDName: "Salesforce Contact ID",
                        IDType: "Person Identifier"
                    }
                }
            });
        }

        setDcSignupSuppression(formEl, personalizationPoint, suppressDays);

        // Show success message
        formDomEl.style.display = "none";
        var successEl = formEl.querySelector(".dc-signup-form-success");
        if (successEl) {
            successEl.style.display = "block";
        }

        var modalDomEl = formEl.querySelector('.dc-signup-form-modal');
        if (modalDomEl) {
        }
    });
}

/**
 * Hides the component if personalization is unavailable or returns no fields.
 * @param {HTMLElement} formEl
 */
function hideForm(formEl) {
    formEl.style.display = "none";
}